import type { MouseEvent, ReactNode } from 'react';
import { useRouter } from '@tanstack/react-router';

export interface UserMessagesLinkProps {
  userId: string;
  className?: string;
  children: ReactNode;
}

/**
 * Everything this person has ever said, on the messages list.
 *
 * A real anchor rather than a router `Link`: `/messages` is still the Vue
 * console's page and declares no search schema yet, so a typed `search` prop is
 * dropped before it reaches the URL. The href is written out and a plain left
 * click is handed to the router, which is what `DataTable` does with a row
 * link — middle click, cmd-click and "copy link" all keep working.
 */
export function UserMessagesLink({ userId, className, children }: UserMessagesLinkProps) {
  const router = useRouter();
  const href = `/messages?user=${encodeURIComponent(userId)}`;

  function follow(event: MouseEvent<HTMLAnchorElement>) {
    if (
      event.button !== 0 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }
    event.preventDefault();
    void router.navigate({ href });
  }

  return (
    <a href={href} className={className} onClick={follow}>
      {children}
    </a>
  );
}
